import _styled from "@emotion/styled/base";
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import { css, keyframes } from '@emotion/react';
import { getResetByTag, rem } from '../../../styles';
import StyledIconPath from './loader.iconpath.styles';
var loaderSpin = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  100% {\n    transform: rotate(360deg) translate3d(0, 0, 0);\n  }\n"])));
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("animation:", loaderSpin, " 1s linear infinite;will-change:transform;height:", rem(40), ";width:", rem(40), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var sizeStyles = function sizeStyles(_ref) {
  var size = _ref.size;
  switch (size) {
    case 'xs':
      return /*#__PURE__*/css("height:", rem(16), ";width:", rem(16), ";", StyledIconPath, "{stroke-width:10;}" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
    case 'sm':
      return /*#__PURE__*/css("height:", rem(24), ";width:", rem(24), ";", StyledIconPath, "{stroke-width:8;}" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
    case 'lg':
      return /*#__PURE__*/css("height:", rem(56), ";width:", rem(56), ";", StyledIconPath, "{stroke-width:4;}" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
    case 'xl':
      return /*#__PURE__*/css("height:", rem(80), ";width:", rem(80), ";", StyledIconPath, "{stroke-width:3;}" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
  }
};
var resetStyles = getResetByTag('svg');
var StyledIcon = /*#__PURE__*/_styled('svg', process.env.NODE_ENV === "production" ? {
  target: "el5vw650"
} : {
  target: "el5vw650",
  label: "StyledIcon"
})(resetStyles, defaultStyles, sizeStyles);
export default StyledIcon;